export default __webpack_public_path__ + "static/media/pow-13-thumb.4456b13f.jpg";